export default class CalculatorStateManager {
	#subscribers = [];
	pricingContext = {};

	constructor(pricingContext) {
		this.pricingContext = pricingContext;
	}

	initEvents() {
		jQuery(document).on(
			'wc-measurement-price-calculator-total-price-change',
			(e, data) => {
				this.pricingContext.productPrice = data?.price;
				this.pricingContext.measurement = data?.measurement_needed;
				this.notify();
			}
		);
		jQuery(document).on('found_variation', 'form.cart', (e, variation) => {
			this.pricingContext.productPrice = variation.display_price;
			this.notify();
		});

		jQuery(document).on('change', 'input[name="quantity"]', (e) => {
			this.pricingContext.quantity = parseFloat(e.target.value);
			this.notify();
		});

		// jQuery(document).on('fpf_price_calculator_change', (e, data) => {
		// 	this.pricingContext.productPrice = data?.price;
		// 	this.notify();
		// });
	}

	notify() {
		this.#subscribers.forEach((subscriber) => {
			subscriber.handleCalculatorChange(this.pricingContext);
		});
	}

	subscribe(subscriber) {
		this.#subscribers.push(subscriber);
	}
}
